<nf-form-control class="form-class">
  <nf-daterange
    id="dateRange"
    [ngModel]="dateRange"
    (ngModelChange)="applyDateRange($event)"
    [beginDateRequired]="false"
    [endDateRequired]="false"
    [min]="minEffectiveDate"
    [max]="maxDate"
  ></nf-daterange>
</nf-form-control>
